/**
 * Component <e2-store-alphabet-carousel />  is used to display the list of all letters of stores city grouped
 * in alphabet order and wrapped in the carousel. Component took data from Redux store.
 *
 * @attr {number} number-of-items-to-show-mobile - number of letters that will be displayed on mobile version
 * HTML Structure Example
 *
 * <e2-store-alphabet-carousel
 *  number-of-items-to-show-mobile="7">
 * </e2-store-alphabet-carousel>
 */

import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { selectors } from '@elab/core/store/store-locator/index';

export class StoreAlphabetCarousel extends SimpleLitElement {
    static get properties() {
        return {
            numberOfItemsToShowMobile: {
                type: Number,
                attribute: 'number-of-items-to-show-mobile',
            },
            scrollShiftDesktop: { type: Number, attribute: 'scroll-shift-desktop' },
            scrollShiftMobile: { type: Number, attribute: 'scroll-shift-mobile' },
            keepSize: {
                type: Boolean,
                attribute: 'keep-size',
            },
            storesLetterList: {
                type: Array,
                attribute: false,
            },
            renderCarousel: {
                type: Boolean,
                attribute: false,
            },
        };
    }

    constructor() {
        super();
        this.numberOfItemsToShowMobile = 7;
        this.scrollShiftDesktop = 0;
        this.scrollShiftMobile = 0;
        this.renderCarousel = true;
        this.keepSize = false;
        this.storesLetterList = [];
    }

    getLetter = letter => html`
        <e2-store-alphabet
            letter="${letter}"
            scroll-shift-desktop="${this.scrollShiftDesktop}"
            scroll-shift-mobile="${this.scrollShiftMobile}"
            class="carousel__letter-slide swiper-slide"
        ></e2-store-alphabet>
    `;

    updated(changedProps) {
        if (changedProps.has('storesLetterList')) {
            if (!this.keepSize) {
                this.numberOfItemsToShowDesktop = this.storesLetterList.length;
            }
            this.renderCarousel = false;
        }
        if (changedProps.has('renderCarousel') && !this.renderCarousel) {
            this.renderCarousel = true;
        }
    }

    render() {
        if (!this.storesLetterList.length) return html``;

        return this.renderCarousel
            ? html`
                  <e2-carousel
                      type="letter"
                      ga-class="carousel__store-alphabet"
                      show-arrows-sm
                      number-of-items-to-show-xxl="${this.storesLetterList.length}"
                      number-of-items-to-show-xl="${this.storesLetterList.length}"
                      number-of-items-to-show-lg="${this.storesLetterList.length}"
                      number-of-items-to-show-md="${this.storesLetterList.length}"
                      number-of-items-to-show-sm="${this.numberOfItemsToShowMobile}"
                      number-of-items-to-slide-sm="${this.numberOfItemsToShowMobile}"
                      number-of-items-to-slide-md="0"
                      not-loop-xxl
                      not-loop-xl
                      not-loop-lg
                      not-loop-md
                      not-loop-sm
                  >
                      <div class="initial-items">
                          ${this.storesLetterList.map(this.getLetter)}
                      </div>
                  </e2-carousel>
              `
            : html``;
    }
}

const mapStateToProps = state => ({
    storesLetterList: selectors.getStoreLetterList(state) || [],
});

export default () =>
    customElements.define(
        'e2-store-alphabet-carousel',
        connect(mapStateToProps, null)(StoreAlphabetCarousel),
    );
